require([
	'jquery',
	'root/Base/Js/MbiImageSize',
	'root/Base/Js/MbiMediaQuery',
	'flickity'
], function(
	$,
	mbiImageSize,
	mbiMq,
	flickity
	) {

	'use strict';

	if($('.section-schnitzl_qualitaet .sliderContainer .slides').length>0){

		var sectionschnitzlqualitaet = new flickity( '.section-schnitzl_qualitaet .sliderContainer .slides', {
			cellSelector: '.slide',
			pageDots: false,
			wrapAround: true,
			prevNextButtons: true,
			watchCSS: false,
			dragThreshold: 20,
			adaptiveHeight: true,
			arrowShape: {
			  x0: 0,
			  x1: 50, y1: 50,
			  x2: 5, y2: 0,
			  x3: 100
			}
		});

		sectionschnitzlqualitaet.on( 'select', function() {
			$('.section-schnitzl_qualitaet .imageContainer .image').removeClass('active');
			$('.section-schnitzl_qualitaet .imageContainer .image.img'+sectionschnitzlqualitaet.selectedIndex).addClass('active');
		});

		$(document).on('click', '.section-schnitzl_qualitaet .sliderContainer .slides a.aButton',function(e){
			e.preventDefault();
			e.stopPropagation();
			sectionschnitzlqualitaet.next();
		});

	}

});
define("root/Assets/Templates/Html/schnitzlqualitaet/Js/schnitzlqualitaet", function(){});

